var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-container',{staticClass:"pt-0 pb-0"},[_c('v-layout',[_c('v-btn',{staticClass:"back-btn",attrs:{"id":"alert-details-back-btn","aria-label":"back-to-alerts","small":"","flat":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0deb02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/alert/BackBreadcrumb.vue
// module id = null
// module chunks = 